import React, { useState } from "react";
import { Link } from "react-router-dom";

const EventsParticipation: React.FC = () => {
  const [selectedCategory, setSelectedCategory] =
    useState<string>("For Institutions");

  const categories = [
    {
      label: "For Institutions",
      content: (
        <>
          <h3 className="text-[#383838] text-base  font-semibold leading-[27px] mb-4">
            For Institutions
          </h3>
          <ul className="list-disc pl-5 space-y-[9px] events-for-students overflow-auto whitespace-normal">
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Promote your university programs to India's top Class 12 and
              Diploma students.
            </li>
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Build long-term Partnerships for Student Admissions
            </li>
            <li className="text-[#383838]  text-base not-italic font-normal leading-[27px]">
              Expand your University’s reach into Tier 2 and Tier 3 student
              markets
            </li>
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Increase College admissions
            </li>
            <li className="text-[#383838] text-base  font-normal leading-[27px]">
              Increase University Brand Visibility
            </li>
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Support Inclusive Education through Scholarships and Education.
            </li>
          </ul>
        </>
      ),
      image:
        "https://cdncollegementor.blob.core.windows.net/application-addmission/what-we-offer-for-institusions.jpg",
      button: {
        text: "Connect with us to participate",
        link: "",
      },
    },
    {
      label: "For Students",
      content: (
        <>
          <h3 className="text-[#383838] text-base  font-semibold leading-[27px] mb-4">
            For Students
          </h3>
          <ul className="list-disc pl-5 space-y-[9px] events-for-students overflow-auto whitespace-normal">
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Meet Top Universities and Get Admission
            </li>
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Find Right Scholarships and Fund your Education
            </li>
            <li className="text-[#383838]  text-base not-italic font-normal leading-[27px]">
              Get Personalized Guidance and Mentoring
            </li>
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Connect with Mentors
            </li>
            <li className="text-[#383838] text-base  font-normal leading-[27px]">
              To Know the trending Courses and Careers
            </li>
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Get Admission into Right College based on your Interest
            </li>
          </ul>
        </>
      ),
      image: "/images/events-for-students.webp",
      button: {
        text: "Connect to Admission mentor",
        link: "",
      },
    },
    {
      label: "For Parents",
      content: (
        <>
          <h3 className="text-[#383838] text-base  font-semibold leading-[27px] mb-4">
            For Parents
          </h3>
          <ul className="list-disc pl-5 space-y-[9px] events-for-students overflow-auto whitespace-normal">
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Talk to Top Universities for your child's future.
            </li>
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Find right scholarships based on your needs.
            </li>
            <li className="text-[#383838]  text-base not-italic font-normal leading-[27px]">
              Get Informed about Courses and Career Opportunities.
            </li>
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Get Quality Mentorship from top mentors and Career Experts.
            </li>
            <li className="text-[#383838] text-base  font-normal leading-[27px]">
              To Empower yourself for making informed, confident college
              admission choices.
            </li>
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Get Right Peer Group for your Children
            </li>
          </ul>
        </>
      ),
      image: "/images/events-for-parents.webp",
      button: {
        text: "Connect to Admission mentor",
        link: "/mentors",
      },
    },

    {
      label: "For Educationalists",
      content: (
        <>
          <h3 className="text-[#383838] text-base  font-semibold leading-[27px] mb-4">
            For Educationalists
          </h3>
          <ul className="list-disc pl-5 space-y-[9px] events-for-students overflow-auto whitespace-normal">
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Join us to Educate, Mentor the future leaders.
            </li>
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Raise awareness about the right scholarships, admissions,
              Mentorship and Trending Careers.
            </li>
            <li className="text-[#383838]  text-base not-italic font-normal leading-[27px]">
              Network with top Academic institutions and Educational Leaders.
            </li>
            <li className="text-[#383838]  text-base  font-normal leading-[27px]">
              Guide Students and provide them Right Opportunities.
            </li>
            <li className="text-[#383838] text-base  font-normal leading-[27px]">
              Advocate for inclusive education, equal opportunities, and Viksit
              Bharat 2047
            </li>
          </ul>
          <span className="text-[#383838] font-normal text-base mt-[9px]">
            "It’s <strong className="font-bold">ME, YOU, WE</strong> - Together
            We Build Futures."
          </span>
        </>
      ),
      image: "/images/evnets-for-educationalist.webp",
      button: {
        text: "Connect with Us",
        link: "",
      },
    },
  ];

  const handleCategoryClick = (category: string) => {
    setSelectedCategory(category);
  };

  return (
    <div className="flex flex-col items-start xl:px-20 py-12 w-full bg-[#F4F6F8] max-md:px-5 max-md:max-w-full max-sm:py-7 min-max-md:px-8 min-max-lg:px-8">
      <div className="md:w-[630px]">
        <h2 className="text-5xl font-bold leading-none text-[#0c9]">
          Why Should You Participate?
        </h2>
        <p className="mt-3 text-base leading-7 text-black  max-md:max-w-full">
          Participate in India's Biggest Scholarship & Admission Fair by College
          Mentor to connect with Top Universities, Meritorious Students, and
          Education Leaders to get New Career and Admission Opportunities.
        </p>
        <span className="text-[#383838]  text-base  font-normal leading-[27px]">
          Its <strong>ME YOU WE</strong> - all Our duty to realise the goal of
          Vikshit Bharat. We started the movement join us to
          make it a Revolution
        </span>
      </div>
      <div className="self-stretch mt-9 max-md:max-w-full">
        <div className="flex gap-8 max-md:flex-col-reverse">
          <div className="relative flex flex-row md:w-[66%] max-md:ml-0 max-md:w-full items-center min-max-md:w-[60%] min-max-lg:w-[60%]  ">
            <div className="bg-[#173CBA] max-md:w-[198px] max-md:text-[12px] max-md:h-[137px] text-white py-4 max-md:py-2 max-md:my-auto rounded-md md:w-[305px] md:h-[211px] my-auto relative z-10 -right-[60px] max-lg:-right-[20px]">
              <ul className="list-none space-y-3 max-md:space-y-1">
                {categories.map((category) => (
                  <li
                    key={category.label}
                    className="hover:text-[#0C9] transition-colors"
                  >
                    <button
                      onClick={() => handleCategoryClick(category.label)}
                      className={`w-full text-left focus:outline-none pl-4 ${
                        selectedCategory === category.label
                          ? "font-semibold text-[#0c9]"
                          : ""
                      }`}
                    >
                      {category.label}
                    </button>
                    <div className="border-b border-white mt-2 max-md:mt-[6px] w-[97px]"></div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="md:w-[562px] md:h-[324px] overflow-hidden max-md:w-[249px]">
              <img
                src={
                  categories.find(
                    (category) => category.label === selectedCategory
                  )?.image
                }
                alt="Whatweoffer"
                className="md:w-[562px] md:h-[324px] max-md:h-[214px] rounded-md "
              />
            </div>
          </div>
          <div className="flex flex-col ml-5 w-[34%] max-md:ml-0 max-md:w-full min-max-md:w-[40%] min-max-lg:w-[40%]">
            <div className="flex flex-col w-full ">
              <div className="flex flex-col text-base leading-7 text-black">
                {
                  categories.find(
                    (category) => category.label === selectedCategory
                  )?.content
                }
              </div>
              {(() => {
                const selected = categories.find(
                  (category) => category.label === selectedCategory
                );
                return selected ? (
                  <Link
                    to={selected.button.link}
                    className="flex gap-0.5 w-[315px] min-max-md:w-full button-styles arrow-button justify-center items-center self-start mt-5 bg-[#0C9] rounded min-h-[32px] arrow-btn hover:bg-[#0c9] text-white"
                    aria-label={selected.button.text}
                  >
                    <span className="self-stretch text-base font-semibold min-max-md:font-light min-max-md:text-[10px]">
                      {selected.button.text}
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="12"
                      viewBox="0 0 15 12"
                      fill="currentColor"
                      className="arrow-icon"
                    >
                      <path
                        d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L9.75736 0.6967C9.46447 0.403806 8.98959 0.403806 8.6967 0.6967C8.40381 0.989593 8.40381 1.46447 8.6967 1.75736L12.9393 6L8.6967 10.2426C8.40381 10.5355 8.40381 11.0104 8.6967 11.3033C8.98959 11.5962 9.46447 11.5962 9.75736 11.3033L14.5303 6.53033ZM1 6.75L14 6.75L14 5.25L1 5.25L1 6.75Z"
                        fill="currentColor"
                      />
                    </svg>
                  </Link>
                ) : null;
              })()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventsParticipation;
